import React, { memo } from "react";
import { Handle, Position } from "react-flow-renderer";
import { Typography, Chip, Box } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { ContentCopy, Delete, ArrowForwardIos } from "@mui/icons-material";
import { MdAccessTime } from "react-icons/md";
import { useNodeStorage } from "../../../stores/useNodeStorage";

// Array com os dias da semana
const daysOfWeeksArray = [
  { value: 0, label: "Dom" },
  { value: 1, label: "Seg" },
  { value: 2, label: "Ter" },
  { value: 3, label: "Qua" },
  { value: 4, label: "Qui" },
  { value: 5, label: "Sex" },
  { value: 6, label: "Sáb" },
];

function ScheduleNode({ data, isConnectable, id }) {
  const theme = useTheme();
  const storageItems = useNodeStorage();

  return (
    <div
      style={{
        backgroundColor: theme.palette.background.paper,
        padding: "8px",
        borderRadius: "8px",
        boxShadow: theme.shadows[3],
        border: `2px solid #ff9800`,
        minWidth: "180px",
      }}
    >
      {/* Handle de entrada */}
      <Handle
        type="target"
        position={Position.Left}
        style={{
          background: "transparent",
          width: "28px",
          height: "28px",
          top: "20px",
          left: "-14px",
          cursor: "crosshair",
          border: "none",
        }}
        isConnectable={isConnectable}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none",
          }}
        >
          <div
            style={{
              background: `linear-gradient(145deg, #ff9800 0%, #f57c00 100%)`,
              width: "20px",
              height: "20px",
              borderRadius: "50%",
              boxShadow: theme.shadows[2],
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "none",
            }}
          >
            <ArrowForwardIos
              style={{
                color: "#fff",
                width: "12px",
                height: "12px",
                transform: "rotate(180deg)",
              }}
            />
          </div>
        </div>
      </Handle>

      {/* Botões de ação */}
      <div
        style={{
          display: "flex",
          position: "absolute",
          right: 5,
          top: 5,
          cursor: "pointer",
          gap: 6,
        }}
      >
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          style={{
            width: "16px",
            height: "16px",
            color: theme.palette.primary.main,
          }}
        />
        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          style={{
            width: "16px",
            height: "16px",
            color: theme.palette.error.main,
          }}
        />
      </div>

      {/* Título */}
      <div
        style={{
          color: theme.palette.text.primary,
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          gap: "4px",
          marginBottom: "8px",
        }}
      >
        <MdAccessTime
          style={{
            width: "18px",
            height: "18px",
            color: "#ff9800",
          }}
        />
        <Typography variant="subtitle2" style={{ fontWeight: "bold" }}>
          Agendamento
        </Typography>
      </div>

      {/* Conteúdo */}
      <Box style={{ fontSize: "12px" }}>
        {/* Dias da semana */}
        {data?.daysOfWeek && data.daysOfWeek.length > 0 ? (
          <Box display="flex" flexWrap="wrap" style={{ gap: "4px", marginBottom: "8px" }}>
            {data.daysOfWeek.map((day, i) => (
              <Chip
                key={i}
                size="small"
                label={daysOfWeeksArray.find((d) => d.value === day)?.label || day}
                style={{
                  backgroundColor: "#ff9800",
                  color: "#fff",
                  fontSize: "10px",
                  height: "20px",
                }}
              />
            ))}
          </Box>
        ) : data?.days ? (
          <Typography
            variant="caption"
            style={{ color: theme.palette.text.secondary, display: "block", marginBottom: "4px" }}
          >
            Após {data.days} dia(s)
          </Typography>
        ) : null}

        {/* Horário */}
        {data?.scheduleAt && (
          <Chip
            size="small"
            label={`às ${data.scheduleAt}`}
            style={{
              backgroundColor: theme.palette.grey[300],
              color: theme.palette.text.primary,
              fontSize: "10px",
              height: "20px",
            }}
          />
        )}

        {/* Mensagem padrão se não houver configuração */}
        {!data?.daysOfWeek?.length && !data?.days && !data?.scheduleAt && (
          <Typography variant="caption" style={{ color: theme.palette.text.secondary }}>
            Clique 2x para configurar
          </Typography>
        )}
      </Box>

      {/* Handle de saída */}
      <Handle
        type="source"
        position={Position.Right}
        id="a"
        style={{
          background: "transparent",
          width: "28px",
          height: "28px",
          top: "50%",
          right: "-14px",
          cursor: "crosshair",
          border: "none",
        }}
        isConnectable={isConnectable}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none",
          }}
        >
          <div
            style={{
              background: `linear-gradient(145deg, #ff9800 0%, #f57c00 100%)`,
              width: "20px",
              height: "20px",
              borderRadius: "50%",
              boxShadow: theme.shadows[2],
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "none",
            }}
          >
            <ArrowForwardIos
              style={{
                color: "#fff",
                width: "12px",
                height: "12px",
              }}
            />
          </div>
        </div>
      </Handle>
    </div>
  );
}

export default memo(ScheduleNode);
